<template>
  <div
    class="w-100 h-100 d-flex"
    @dragenter="onDragEnter"
    @dragover="onDragOver"
    @dragleave="onDragLeave"
    @drop="onDrop"
  >
  <b-input-group class="zfile-input" :class="{ 'is-dragover': isDragOver }">
    <input
      v-show="false"
      ref="fileInput"
      type="file"
      @change="handleFileChange"
    />
    <b-form-input
      class="pointer"
      type="text"
      :value="file ? file.name : ''"
      :placeholder="placeholder"
      readonly
      @click="openFilePicker"
    />
    <b-input-group-text>
      <span class="pointer" @click="openFilePicker">
        <i class="fas fa-file"/>
      </span>
    </b-input-group-text>
  </b-input-group>
  </div>
</template>

<script>
export default {
  props: {
    value: File,
    placeholder: String
  },
  data () {
    return {
      file: this.value || null,
      isDragOver: false,
      // dragenter/dragleave disparam em cada filho; o contador evita piscar o destaque
      dragDepth: 0
    }
  },
  methods: {
    openFilePicker () {
      this.$refs.fileInput.click()
    },
    handleFileChange (event) {
      const newFile = event.target.files[0]
      if (newFile) {
        this.selectFile(newFile)
      }
    },
    setFile (newFile) {
      this.file = newFile
      this.$emit('input', newFile)
    },
    selectFile (newFile) {
      this.setFile(newFile)
      this.$emit('file-selected', newFile)
    },
    hasFiles (event) {
      const types = event.dataTransfer ? event.dataTransfer.types : null
      return !!types && Array.prototype.indexOf.call(types, 'Files') !== -1
    },
    // stopPropagation: o App.vue tem listener global em window que zera o dropEffect
    // de qualquer alvo fora de #dropzoneId; sem barrar a subida o drop continua bloqueado
    onDragEnter (event) {
      if (!this.hasFiles(event)) return
      event.preventDefault()
      event.stopPropagation()
      this.dragDepth++
      this.isDragOver = true
    },
    onDragOver (event) {
      if (!this.hasFiles(event)) return
      event.preventDefault()
      event.stopPropagation()
      event.dataTransfer.dropEffect = 'copy'
    },
    onDragLeave (event) {
      if (!this.hasFiles(event)) return
      this.dragDepth = Math.max(this.dragDepth - 1, 0)
      if (this.dragDepth === 0) {
        this.isDragOver = false
      }
    },
    onDrop (event) {
      if (!this.hasFiles(event)) return
      event.preventDefault()
      this.dragDepth = 0
      this.isDragOver = false

      // campo aceita um arquivo so; com varios soltos fica o primeiro
      const newFile = event.dataTransfer.files[0]
      if (newFile) {
        this.selectFile(newFile)
      }
    }
  },
  watch: {
    value (newFile) {
      this.file = newFile
    }
  }
}
</script>

<style lang="scss" scoped>
.zfile-input {
  .form-control {
    border-right: 0px;
  }

  .input-group-text {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
  }

  &.is-dragover {
    .form-control,
    .input-group-text {
      border-style: dashed;
      border-color: var(--primary, #006837);
    }

    .form-control {
      background-color: rgba(0, 104, 55, 0.08);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/forms/ZFileInput.vue